import React, { useState } from "react";
import { toast } from "react-toastify";
import Handler from "../../Helpers/Handler";
import { DetailCard } from "../../Components/Needed";
import { FaFlask } from "react-icons/fa";

// Test mode: the customer's NEW bookings are paid on the Razorpay test account (no real money) and are left out of
// dashboards, money totals, owner payouts and referral rewards. Bookings keep the mode they were made with. Only an
// admin can change it (the switch saves at once and is audited); staff see the value read only. Missing = off.
const TestModeCard = ({ customerId, customer, canEdit = false, basePath = "/admin/customer", onChanged }) => {
    const [saving, setSaving] = useState(false);
    const on = customer?.testMode === true;

    const toggle = async () => {
        setSaving(true);
        const response = await Handler({ method: "patch", url: `${basePath}/${customerId}/test-mode`, data: { testMode: !on } });
        setSaving(false);
        if (response?.success) {
            toast.success(response?.data?.message || "Updated");
            onChanged?.();
        } else {
            toast.error(response?.data?.message || "Could not change test mode");
        }
    };

    return (
        <DetailCard title="Test mode" icon={<FaFlask />}>
            <div className="d-flex align-items-center justify-content-between gap-3">
                <div>
                    <div className="fw-semibold">{on ? "On" : "Off"}</div>
                    <div className="small text-muted">
                        {on
                            ? "New bookings use the Razorpay test account: no real money, left out of dashboards and totals."
                            : "When on, new bookings use the Razorpay test account (no real money)."}
                        {" "}Existing bookings keep their mode. Only an admin can change it.
                    </div>
                </div>
                {canEdit ? (
                    <div className="form-check form-switch fs-4 m-0">
                        <input className="form-check-input" type="checkbox" role="switch" aria-label="Test mode" checked={on} disabled={saving} onChange={toggle} />
                    </div>
                ) : (
                    <span className={`badge bg-${on ? "warning text-dark" : "secondary"}`}>{on ? "On" : "Off"}</span>
                )}
            </div>
        </DetailCard>
    );
};

export default TestModeCard;
